import React from 'react';
import { Grid, Dialog, DialogContent, Typography, Button } from '@material-ui/core';
import { Button as VeeraButton } from 'katri-map';

interface Props {
  isOpen: boolean;
  onClose: (event: MouseEvent, reason: string) => void;
  onLogout: () => void;
  onExtendSession: () => void;
  secondsUntilSessionEnd: number;
}

const ExtendSessionModal = ({
  isOpen,
  onClose,
  onLogout,
  onExtendSession,
  secondsUntilSessionEnd,
}: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='md'>
      <DialogContent>
        <Grid container spacing={2} alignContent='center' justifyContent='center'>
          <Grid item xs={12}>
            <Typography variant='h6'>{`Sessioon aegub ${secondsUntilSessionEnd} sekundi pärast`}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle2' style={{ fontWeight: 400 }}>
              Kas soovite sessiooni jätkata?
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button
              style={{ textTransform: 'none' }}
              color='primary'
              onClick={() => onLogout()}
              disableElevation
              type='submit'
            >
              Ei
            </Button>
            <VeeraButton
              style={{ marginLeft: 16 }}
              type='button'
              label='Jah'
              onClick={() => onExtendSession()}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ExtendSessionModal;
